import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { BreadcrumbsItemType } from "../../../../app/components/BreadcrumbsBox";
import ActionTextIcon from "../../../../common/components/icons/ActionTextIcon";
import { DocumentNodeType } from "../../enums";
import { DocumentNodeTree } from "../../types";
import styles from "./DocumentNodeBreadcrumbsView.module.scss";

interface Props {
  breadcrumbs?: DocumentNodeTree[];
  treeNodeType: DocumentNodeType;
  onClickBreadcrumb: (treePath: string) => void;
}

const DocumentNodeBreadcrumbsView = ({ breadcrumbs, treeNodeType, onClickBreadcrumb }: Props) => {
  const { t } = useTranslation();

  const getItems = () => {
    const items: BreadcrumbsItemType[] = [
      {
        title: (
          <ActionTextIcon
            onClick={() => onClickBreadcrumb("")}
            icon="home"
            color="blue"
            text={t(`documentNode.enums.documentNodeType.${treeNodeType}`)}
          />
        ),
      },
    ];

    breadcrumbs?.map((breadcrumb, index) =>
      index === breadcrumbs.length - 1
        ? items.push({ title: breadcrumb.name, className: styles.documentsBreadcrumbsLink })
        : items.push({
            title: (
              <span className={styles.documentsBreadcrumbsLink} onClick={() => onClickBreadcrumb(breadcrumb.treePath)}>
                {breadcrumb.name}
              </span>
            ),
          }),
    );

    return items;
  };

  return (
    <div className={styles.documentsBreadcrumbs}>
      <Breadcrumb items={getItems()} />
    </div>
  );
};

export default DocumentNodeBreadcrumbsView;
